import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';

import { InvitedByService } from 'src/app/services/setting/invited-by.service';

import { GuestStatisticComponent } from 'src/app/components/guest/guest-statistic/guest-statistic.component';
import { SettingField } from 'src/app/interfaces/database';
import { GuestStatisticType } from 'src/app/types/statistic';


/**
 * Guest home page
 */
@Component({
  selector: 'app-guest-home',
  templateUrl: './guest-home.page.html',
  styleUrls: ['./guest-home.page.scss'],
})
export class GuestHomePage implements OnInit, OnDestroy {

  @HostListener('window:resize', ['$event'])onResize(event: any) {
    this.resizeCount = 0;
    this.setupSlidePerView();
  }
  /**
   * Watch screen orientation change for login slider setup
   */
  @HostListener('window:orientationchange', ['$event']) onOrientationChange(event: any) {
    this.resizeCount = 0;
    this.setupSlidePerView();
  }
  /**
   * Ion content
   */
  @ViewChild('content', { read: ElementRef }) content: ElementRef;

  reset: boolean;

  ready: boolean;
  /**
   * Invited by of statistic
   */
  invitedBy: SettingField | string;
  /**
   * Invited by list
   */
  invitedByList: SettingField[];

  settingFieldSlidePerView: number;
  statisticSlidePerView: number;
  /**
   * Invited by list subscription
   */
  private invitedBySubscription: Subscription;

  private resizeCount: number;

  /**
   * Constructor
   * @param platform platform
   * @param router router
   * @param modalController modal controller
   * @param invitedByService Invited by service
   * @param functionService Function service
   */
  constructor(
    private modalController: ModalController,
    private invitedByService: InvitedByService,
  ) { }

  ngOnInit(): void {
    this.reset = true;
    this.ready = true;
  }

  ngOnDestroy(): void {
    this.reset = false;
    this.ready = false;
    this.unwatch();
  }

  /**
   * Before page enter.
   * Reset invited by to all.
   * Start watching invited by list
   */
  ionViewWillEnter() {
    this.reset = true;
    this.invitedBy = '';
    this.watch();
  }

  ionViewDidEnter() {
    this.resizeCount = 0;
    this.setupSlidePerView();
  }
  /**
   * Before page leave.
   * Unwatch invited by list
   */
  ionViewWillLeave() {
    this.unwatch();
  }

  watch() {
    this.watchInvitedBy();
  }

  unwatch() {
    this.unwatchInvitedBy();
  }

  /**
   * Watch invited by list
   */
  async watchInvitedBy() {
    if (!this.invitedBySubscription) {
      this.invitedBySubscription = this.invitedByService.observableInvitedbyList.subscribe((invitedByList: SettingField[]) => {
        this.invitedByList = this.invitedByService.getInvitedByList();
      });
    }
    
  }

  /**
   * Unwatch invited by list
   */
  async unwatchInvitedBy() {
    if (this.invitedBySubscription) {
      this.invitedBySubscription.unsubscribe();
      this.invitedBySubscription = null;
    }
  }

  setupSlidePerView() {
    if (this.content?.nativeElement?.offsetWidth && this.resizeCount < 3) {
      this.statisticSlidePerView = this.getStatisticSlidesPerView();
      this.settingFieldSlidePerView = this.getSettingFieldSlidesPerView();
    } else {
      this.resizeCount += 1;
      setTimeout(() => {
        this.setupSlidePerView();
      }, 300);
    }
  }

  getStatisticSlidesPerView() {
    const itemWidth = 100;
    const maxSlides = 5;
    let slidesPerView = 4;

    let cardWidth = this.content?.nativeElement?.offsetWidth ? this.content.nativeElement.offsetWidth : window?.innerWidth;

    slidesPerView = Math.floor((cardWidth - 32) / itemWidth);
    if (!slidesPerView || slidesPerView < 1) {
      slidesPerView = 1;
    }
    if (slidesPerView >= maxSlides) {
      slidesPerView = maxSlides;
    } else {
      slidesPerView = slidesPerView + 0.2;
    }
    return slidesPerView;
  }


  getSettingFieldSlidesPerView() {
    const itemWidth = 90;
    const maxSlides = 5;
    let slidesPerView = 4;

    let cardWidth = this.content?.nativeElement?.offsetWidth ? this.content.nativeElement.offsetWidth : window?.innerWidth;
    cardWidth = cardWidth - 32 - (itemWidth / 2);

    slidesPerView = Math.floor(cardWidth / itemWidth);
    if (!slidesPerView || slidesPerView < 1) {
      slidesPerView = 1;
    }
    if (slidesPerView >= maxSlides) {
      slidesPerView = maxSlides;
    } else {
      slidesPerView = slidesPerView + 0.5;
    }
    return slidesPerView;
  }

  /**
   * Present guest statistic modal
   * @param statisticType Statistic type
   */
  async presentGuestStatisticModal(statisticType: GuestStatisticType) {
    const modal = await this.modalController.create({
      component: GuestStatisticComponent,
      cssClass: '',
      componentProps: {
        statisticType,
        attendingType: statisticType === 'attending' ? statisticType : '',
        seatingType: statisticType === 'seating' ?  'assigned' : '',
        qrcodeType: statisticType === 'qrcode' ? 'sent' : '',
        module: 'guest',
      }
    });
    modal.present();
  }

  doRefresh(event: any) {
    this.reset = false;
    setTimeout(() => {
      this.reset = true;
      event?.target?.complete();
    }, 500);
  }

  // async setupGroup() {
  //   const guestList = this.guestService.guestList;
  //   console.log("🚀 ~ file: sms-home.page.ts ~ line 131 ~ SmsHomePage ~ setupGroup ~ guestList", guestList)
  //   const groupList = this.groupService.groupList;
  //   for (let guest of guestList) {
  //     if (guest?.groupId) {
  //       const index = groupList.findIndex((x) => x.groupId === guest.groupId );
  //       console.log("🚀 ~ file: sms-home.page.ts ~ line 136 ~ SmsHomePage ~ setupGroup ~ index", index)
  //       if (index === -1) {
  //         const group: Group = {
  //           groupId: guest.groupId,
  //           groupName: guest.name,
  //           mobile: guest.mobile,
  //           email: guest.email,
  //           createBy: guest.createBy,
  //           updateBy: guest.updateBy,
  //         };
  //         console.log(group);
  //         await this.groupManageService.saveGroupList([ guest.groupId ], group, [ group ]);
  //       }
  //     }
  //   }
  // }

}
